import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import JoinTheExpedition from "./sections/JoinTheExpedition";
import CommonInquiries from "./sections/CommonInquiries";
import RodapeItc from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <JoinTheExpedition />
      <CommonInquiries />
      <RodapeItc />
    </div>;
}